import request from '@/util/request'
import {removeToken, removeRefreshToken,removeUserInfo} from '@/util/auth'
import qs from 'qs'
import sha256 from 'sha256'

export function login(loginType,username,password,orgId,type){
    switch(loginType){
        case "mobile":loginType=1;break;
        case "eMail":loginType=2;break;
        case "username":loginType=3;break;
    }
    window.deviceConfigOption=null;//清空设备控制配置数据
	let oPasssword=password;
	if(!type&&stage.loc.loginSystem.sha256) password=sha256(password);
	return request({
		url: `/oauth-s/oauth/token`,
		method: 'post',
		data: qs.stringify({
			grant_type:"password",
            identity_type:loginType,//1：手机号、2：邮箱、3：用户名
			username,
			password,
			clear_text_pwd:oPasssword,//明文，后端针对二期迁移的账号逻辑需要
			client_id:'test',
			org_id:orgId||undefined,
			password_type:type//captcha
		}),
		headers: { 'Content-type': 'application/x-www-form-urlencoded' }
	})
}

export function SIMLogin(url, data) {
	return request({
		url: `/sim_s${url}`,
		method: 'post',
		data
	})
}

export function SIMLogout(url, data) {
	return request({
		url: `/sim_s${url}`,
		method: 'post',
		data
	})
}

export function getUserInfo() {
	let data=request({
		url: `/user-s/acc/org/login-user`,
		method: 'get',
		params:{language:stage.languageId}
	});
	data.then(success=>{//处理关键数据
		if(success.organization){//选择商家之前会拿不到商家信息
			stage.time.timeZoneCode=success.organization.timezone;
			stage.time.timeZone = mz.tz(success.organization.timezone).format("Z"); //时区转成可读小时分
			stage.time.offset = mz.tz(success.organization.timezone)._offset * 60 * 1000; //时区转成毫秒

			stage.powerTypeList=[];//记录可用的能源类型
			if(success.organization.operateObject.includes("1")) stage.powerTypeList.push("PV");
			if(success.organization.operateObject.includes("2")) stage.powerTypeList.push("WIND");
			// switch(success.organization.operateObject){
			// 	case "1":stage.powerTypeList=["PV"];break;
			// 	case "2":stage.powerTypeList=["PV","WIND"];break;
			// }
		}
	});
	return data;
}

// 根据userInfo 中的职能id 获取用户登陆后的职能权限
export function getFunctions(functionId) {
	return request({
		url: `/auth-s/auth/role/${functionId}/function`,
		method: 'get'
	})
}

// 根据userInfo 中的角色id 获取用户登陆后的角色权限
export function getRoles(roleId) {
	let data=request({
		url: `/auth-s/auth/role/${roleId}`,
		method: 'get'
	});
	data.then(success=>{
		localStorage.setItem("businessTypeRole",success.role.businessType);
	});
	return data;
}

//获取商家列表
export function apiGetOrgList(){//userId
	return request({
		url: `/user-s/acc/org/my`,
		method: 'get',
		params:{language:stage.languageId}
	});
}

//根据refresh_token刷新access_token
export function getRefreshToken(url, data) {
	return request({
		url: `/oauth_s${url}`,
		method: 'post',
		data: qs.stringify(data),
		headers: { 'Content-type': 'application/x-www-form-urlencoded' }
	})
}

export function logout() {
	localStorage.clear()
	return new Promise((resolve, reject) => {
		removeToken()
		removeRefreshToken()
		resolve()
	})
}

//前端退出
export function frontLogout() {
	return new Promise(resolve => {
		removeToken()
		removeRefreshToken()
		resolve()
	})
}

//获取验证码
export function apiGetVerificationCode(target,action,type){
	let url="",requestType="";
	switch(type){
		case "eMail":url=`/user-s/acc/user/email/${target}/captcha`;requestType="mail";break;
		case "mobile":url=`/user-s/acc/user/phone-number/${target}/captcha`;requestType="sms";break;
	}
	return request({
		url,
		method: 'post',
		params:{
			language:stage.languageId,
			type:requestType,
			system:stage.loc.customer,
			captchaPurpose:action//用途（注册：reg，重置密码：reset_pwd，绑定：bind）
		}
	});
	// return new Promise(resolve=>{
	// 	resolve("");
	// });
}

//进行注册
// export function apiRegister(data,verifiCode){
// 	return request({
// 		url:`/oauth-s/acc/user`,
// 		method: 'post',
// 		data:{
// 			userInfo:{
// 				//
// 			},
// 		}
// 	});
// }

//完善个人信息
export function apiFillUserInfo(data,password){//data:{name,username,countryCode,phoneNumber}
    data.system=stage.loc.customer;
	return request({
		url:`/user-s/acc/register`,
		method: 'post',
		data:{
			credential:stage.loc.loginSystem.sha256? sha256(password):password,
			userInfo:data
		}
	});
	// return new Promise(resolve=>{
	// 	resolve("");
	// });
}


//完善商家信息=给账号添加商家
export function apiAddOrg(data){//data:{name,username,countryCode,phoneNumber}
// data:{
//   "adminCountryCode": "string",
//   "adminEmail": "string",
//   "adminId": 0,
//   "adminName": "string",
//   "adminPhoneNumber": "string",
//   "nameList": [
//     {
//       "id": 0,
//       "language": "string",
//       "name": "string",
//       "relateId": 0,
//       "relateType": 0
//     }
//   ],
//   "org": {
//     "adminId": 0,
//     "areaId": 0,
//     "businessType": "string",
//     "id": 0,
//     "logo": "string",
//     "name": "string",
//     "timezone": "string",
//     "topGroupId": 0,
//     "type": 0
//   },
//   "roleId": 0
// }
 	data.org.system=stage.loc.customer;
	return request({
		url:`/user-s/acc/org/register`,
		method: 'post',
		data
	});
	// return new Promise(resolve=>{
	// 	resolve("");
	// });
}
//获取隐私协议阅读状态
export function getPrivacyPolicy(params){//userId
	return request({
		url: `/user-s/acc/user/privacy-policy-read-status`,
		method: 'get',
		params
	});
}
//隐私协议已读
export function setPrivacyPolicyYes(data){//userId
	return request({
		url: `/user-s/acc/user/privacy-policy-read-status/yes`,
		method: 'post',
		data
	});
}


// WEBPACK FOOTER //
// ./src/api/login.js